import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobPartActions'
import * as api from '../../api/job/parts'

function* getJobParts(action) {
  try {
    const payload = yield call(api.getJobParts, action.jobId)
    yield put({ type: constants.GET_JOB_PARTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_JOB_PARTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetJobParts() {
  yield takeLatest(constants.GET_JOB_PARTS.ACTION, getJobParts)
}

function* addJobPart(action) {
  try {
    const payload = {
      job_part_data: {
        job_id: action.jobId,
        item_id: action.content.itemId,
        name: action.content.name,
        description: action.content.description,
        cost: action.content.cost,
        created_by_id: action.userId,
        updated_by_id: action.userId
      }
    }
    yield call(api.addJobPart, payload)
    yield put({ type: constants.ADD_JOB_PART.SUCCESS, payload })
    yield call(getJobParts, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_JOB_PART.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddJobPart() {
  yield takeLatest(constants.ADD_JOB_PART.ACTION, addJobPart)
}

function* updateJobPart(action) {
  try {
    const payload = {
      part_id: action.partId,
      job_part_data: {
        job_id: action.jobId,
        item_id: action.content.itemId,
        name: action.content.name,
        description: action.content.description,
        cost: action.content.cost,
        created_by_id: action.userId,
        updated_by_id: action.userId
      }
    }
    yield call(api.updateJobPart, payload)
    yield put({ type: constants.UPDATE_JOB_PART.SUCCESS, payload })
    yield call(getJobParts, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_JOB_PART.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobPart() {
  yield takeLatest(constants.UPDATE_JOB_PART.ACTION, updateJobPart)
}

function* deleteJobPart(action) {
  try {
    const payload = {
      part_id: action.partId
    }
    yield call(api.deleteJobPart, action.partId)
    yield put({ type: constants.DELETE_JOB_PART.SUCCESS, payload })
    yield call(getJobParts, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_JOB_PART.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobPart() {
  yield takeLatest(constants.DELETE_JOB_PART.ACTION, deleteJobPart)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetJobParts),
    fork(watchAddJobPart),
    fork(watchUpdateJobPart),
    fork(watchDeleteJobPart)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobPartSaga.js